module.exports = __webpack_public_path__ + "static/media/checkbox-arrow.675a9198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/general/checkbox-arrow.svg
// module id = 1112
// module chunks = 0